import { useEffect, useState } from 'react'
import { getDictByKey } from '../../api/dictionaryService'

interface UseFaceIdGrayControlResult {
  shouldUseFaceId: boolean
  isEnvWeixin: boolean
}

export default function useFaceIdGrayControl(): UseFaceIdGrayControlResult {
  const [grayRate, setGrayRate] = useState(0)
  const [shouldUseFaceId, setShouldUseFaceId] = useState(false)
  const [randomBucket] = useState(() => Math.floor(Math.random() * 100))
  const isEnvWeixin = /MicroMessenger/i.test(window.navigator.userAgent)

  useEffect(() => {
    getDictByKey('key_wechat_faceid_gray_rate')
      .then((value) => {
        const rate = parseInt(value, 10)
        if (!isNaN(rate) && rate >= 0 && rate <= 100) {
          setGrayRate(rate)
        }
      })
      .catch(() => {
        setGrayRate(0)
      })
  }, [])

  useEffect(() => {
    if (isEnvWeixin) {
      setShouldUseFaceId(randomBucket < grayRate)
    } else {
      setShouldUseFaceId(false)
    }
  }, [grayRate, isEnvWeixin, randomBucket])

  return {
    shouldUseFaceId,
    isEnvWeixin,
  }
}
